/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useRef, useEffect } from "react";
import Tabs from "../Tabs";

const InstantPaymentMethods = (props) => {
    const {
        acceptedPayments,
        handleTabClick,
        hasToggledPaymentMethodView,
        numberOfStandardPaymentMethods,
    } = props;

    const singlePaymentMethodTitleRef = useRef(null);

    // If the use a new payment method was clicked move the focus to the tabs
    // or heading text so that the user can seamlessly tab through the new
    // payments method UI
    useEffect(() => {
        if (
            hasToggledPaymentMethodView &&
            numberOfStandardPaymentMethods === 1
        ) {
            singlePaymentMethodTitleRef?.current?.focus();
        }
    }, [hasToggledPaymentMethodView, numberOfStandardPaymentMethods]);

    return numberOfStandardPaymentMethods > 1 ? (
        <div className="col col--12 -padding-top--0 -padding-left--0">
            <Tabs
                handleClick={handleTabClick}
                size="regular"
                tabData={acceptedPayments}
                hasToggledPaymentMethodView={hasToggledPaymentMethodView}
            />
        </div>
    ) : (
        <>
            <h4 tabIndex="0" ref={singlePaymentMethodTitleRef}>
                {acceptedPayments[0]?.label}
            </h4>
            {acceptedPayments[0]?.content}
        </>
    );
};

export default InstantPaymentMethods;
